import React from 'react'
import useStyles from '../SalesBadge/SalesBadge.styles'
import clsx from 'clsx'
export type Props = {
  backgroundColor?: 'FF_SHARP_YELLOW' | 'FF_PLUSH_BLUSH' | 'FF_LAZY_LIME'
  contentLine1?: string
  contentLine2?: string
  largeFontCheck?: 'contentLine1' | 'contentLine2'
  isFromProductCard?: boolean
}

const SalesBadge = (props: Props) => {
  const { backgroundColor, contentLine1, contentLine2, largeFontCheck, isFromProductCard } = props
  const { classes } = useStyles()
  const variantClass = backgroundColor?.toUpperCase()
  const isLargeContent1 = largeFontCheck === 'contentLine1'
  const isLargeContent2 = largeFontCheck === 'contentLine2'
  const line1LargeFont =
    isLargeContent1 && isFromProductCard ? 'plpLargeText' : isLargeContent1 && !isFromProductCard ? 'largeText' : ''
  const line2LargeFont =
    isLargeContent2 && isFromProductCard ? 'plpLargeText' : isLargeContent2 && !isFromProductCard ? 'largeText' : ''
  const smallTextLine1 = !isLargeContent1 && isFromProductCard ? 'plpSmallText' : 'smallText'
  const smallTextLine2 = !isLargeContent2 && isFromProductCard ? 'plpSmallText' : 'smallText'
  const line1 = isLargeContent1 ? contentLine1?.slice(0, 4) : contentLine1?.slice(0, 10)
  const line2 = isLargeContent2 ? contentLine2?.slice(0, 4) : contentLine2?.slice(0, 10)
  return (
    <div
      className={clsx(
        classes.container,
        variantClass ? classes[variantClass as keyof typeof classes] : '',
        isFromProductCard ? classes.plpContainer : classes.pdpContainer
      )}
    >
      {contentLine1 && (
        <div className={clsx(classes[smallTextLine1], classes[line1LargeFont as keyof typeof classes])}>{line1}</div>
      )}
      {contentLine2 && (
        <div className={clsx(classes[smallTextLine2], classes[line2LargeFont as keyof typeof classes])}>{line2}</div>
      )}
    </div>
  )
}

export default SalesBadge
